import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppSettings } from './../app.settings';
import { NotificationsService } from './notifications.service';
import { StorageService } from './storage.service';
import { UserCommonService } from './user-common.service';

@Injectable()
export class AuthenticationValidationService implements CanActivate {
  userMeResponse: any;

  constructor(
    private storageService: StorageService,
    private router: Router,
    private notificationService: NotificationsService,
    private userCommonService: UserCommonService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!state.url.includes('file/export')) {
      this.setTagList();
    }
    const interval = +this.storageService.getItemLocalStorage(AppSettings.INTERVAL);
    if (interval && interval > 0) {
      return this.checkIfValidUser(state);
    }

    localStorage.setItem('returnUrl', state.url);
    this.router.navigate(['/signin']);
  }

  checkIfValidUser(state): Promise<boolean> {
    return new Promise(res => {
      this.userCommonService.userMe().subscribe((result: any) => {
        if (result && this.userCommonService.isUserActivated(result)) {
          this.userMeResponse = result;
          this.storageService.setItem('headerAccessPermissionDispatch', result.addDispatch);
          if (this.userMeResponse.accessGroup !== null && this.userMeResponse.accessGroup.length > 0) {
            this.notificationService.canFetchNotification = true;
            this.setSessionAndUserDetails(result);
            if (this.userCommonService.isRolesAndGenerateSidebar === false) {
              this.userCommonService.setRolesAndGenerateSidebar();
            }
          }
          res(true);
          return true;
        } else if (result && !this.userCommonService.isUserActivated(result)) {
          this.notificationService.canFetchNotification = false;
          this.notificationService.stopFetchingNotifications();
          res(false);
          this.userCommonService.forceLogoutInactiveUser();
          return false;
        } else {
          this.notificationService.canFetchNotification = false;
          res(false);
          localStorage.setItem('returnUrl', state.url);
          this.router.navigate(['/signin']);
          return false;
        }
      }, (err) => {
        this.notificationService.canFetchNotification = false;
        localStorage.setItem('returnUrl', state.url);
        this.router.navigate(['/signin']);
        res(false);
        return false;
      });
    });
  }

  setSessionAndUserDetails(results) {
    this.storageService.setItem(AppSettings.USER_DETAILS, results.user);
    this.storageService.setItem(AppSettings.ACCESS_MENU, this.userMeResponse.accessGroup);
    const userRoleArr = results.user.roles.filter(ele => ele.id !== '4');
    this.storageService.setItem(AppSettings.USER_ROLE_ID, +userRoleArr[0]?.id);
    sessionStorage.setItem(AppSettings.PROVIDER_ID, results.user.id);
    AppSettings.USER = results.user;
    this.userCommonService.getDispatchListFilter();
    if (results.user.userDetails !== null) {
      this.storageService.setItem(AppSettings.CURRENT_USER_CORPORATE_ID, results.user.userDetails.corporateId);
    }
  }

  setTagList() {
    this.userCommonService.getTagsListApi().subscribe(result => {
      this.storageService.setItem(AppSettings.TAG_DATA, result);
      localStorage.setItem('localTagdata', JSON.stringify(result));
    }, (error) => {
    });
  }

}

